package org.moxultimate.topwithmox.theme

import org.moxultimate.topwithmox.utils.ColorUtils.hexToColorRgb


/**
 * Background
 */

val SemiBlackTransparentBG = hexToColorRgb(hex = "#000000", alpha = 0.3f)

val SemiWhiteTransparentBG = hexToColorRgb(hex = "#FFFFFF", alpha = 0.5f)

val BlackBG = hexToColorRgb(hex = "#000000")

val WhiteBG = hexToColorRgb(hex = "#FFFFFF")




/**
 * Texts
 */

val WhiteTextColor = hexToColorRgb(hex = "#FFFFFF")

val DarkTextColor = hexToColorRgb(hex = "#262525")

val DarkGrayColor = hexToColorRgb(hex = "#757575")



/**
 * Semantic UI accents
 */

val ProsGreenColor = hexToColorRgb(hex = "#4CAF50")

val ConsRedColor = hexToColorRgb(hex = "#E53935")

val DiscountOrangeColor = hexToColorRgb(hex = "#FF7034")


/**
 * Icons
 */


